import '@/bootstrap'
import Vue from 'vue'
import App from '@/App.vue'
import '@/registerServiceWorker'
import router from '@/routes/router'
import { store } from '@/store'
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

import _ from './utils'
// import consoletodiv  from '@lmkhwana/consoletodiv';
import { i18n } from './i18n.js';


Vue.use(VueTour)

import '@/assets/sass/app.scss'
const googleAppId = process.env.VUE_APP_GOOGLE_APP_ID;

import GoogleAuth from '@/plugins/google_oAuth.js'
const gauthOption = {
    clientId: googleAppId,
    scope: 'profile email',
    prompt: 'select_account'
}
Vue.use(GoogleAuth, gauthOption)

Vue.config.productionTip = false


export default new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

// consoletodiv('logger')

